import { http } from '../http'
import { secureLocalStorageGet } from '../../helpers/index'
import userGWFragments from '@shared/hooks/usegwFragments'

interface RequestDataType {
  startDate: string,
  endDate: string,
  searchText: string,
  status:string
}
export const getAllUsersList = async (value:RequestDataType): Promise<any[]> => { // todo: value send as params
  const userFragments = userGWFragments()
  
  
  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/short-list',
      data: {
        page: 0,
        pageCount: 10,
        ...value,
        ...userFragments,
      },
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.message)
  }

  return data.data.data
}
